import { render, staticRenderFns } from "./qMsgBox.vue?vue&type=template&id=332dfc30&scoped=true&"
import script from "./qMsgBox.vue?vue&type=script&lang=js&"
export * from "./qMsgBox.vue?vue&type=script&lang=js&"
import style0 from "./qMsgBox.vue?vue&type=style&index=0&id=332dfc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332dfc30",
  null
  
)

export default component.exports